import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="light" className="titleBlock-align-left simple-integration" id="Seamless" mdxType="TitleBlock" />
    <h3 {...{
      "id": "seamless-and-simple-integration-with-your-existing-apps"
    }}>{`Seamless and simple integration with your existing apps.`}</h3>
    <p>{`Build low-code document automation services that are connected to the applications and services you and your teams are already using.`}</p>
    <TextBlock slots="assetImg" theme="lightest" width="33%" imageOnly className="padding_top_align padding-zero imageHightAuto sample-integration_bg" mdxType="TextBlock" />
    <p>{`sample-integration_ms`}</p>
    <TextBlock slots="assetImg" theme="lightest" width="33%" imageOnly className="padding_top_align padding-zero imageHightAuto sample-integration_bg" mdxType="TextBlock" />
    <p>{`sample-integration_workFront`}</p>
    <TextBlock slots="assetImg" theme="lightest" width="33%" imageOnly className="padding_top_align padding-zero imageHightAuto sample-integration_bg" mdxType="TextBlock" />
    <p>{`sample-integration_UiPath`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      